import { render, staticRenderFns } from "./ship-modal.vue?vue&type=template&id=0bb7a527"
import script from "./ship-modal.vue?vue&type=script&lang=js"
export * from "./ship-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports